import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import * as THREE from 'three-full';
// import * as GLTFLoader from 'three-gltf-loader';
// import "./js/EnableThreeExamples";
// import "three/examples/js/controls/OrbitControls";
// import "three/examples/js/loaders/ColladaLoader";
// require('three-reflector/index');
// import * as dat from 'dat.gui';

var WIDTH = window.innerWidth;
var HEIGHT = window.innerHeight;
// camera

declare var $: any;

let subThis;

@Component({
  selector: 'app-scene',
  templateUrl: './scene.component.html',
  styleUrls: ['./scene.component.css']
})
export class SceneComponent implements OnInit {

  selectedPiece: any = false;
	container: any;
	camera: any;
	scene: any;
  renderer: any;
  clock: any;
	loader: any;
	mixers: any = [];
  avatars: any = [];
  backgrounds: any = [
	  // asbar
	  "https://media0.giphy.com/media/26FeZv1SFoKhYFUu4/giphy.gif?cid=ecf05e4780af228f8f1689feeeca1affc139247f478b0570&rid=giphy.gif", 
	  "assets/ok.gif",  
	  "assets/plane.gif", 
	  "assets/burgers.gif", 
	  "assets/bg.gif",  
	  "assets/space.gif", 
	  "assets/ok.gif", 
	  "assets/cat.gif",
	  "https://media1.giphy.com/media/i2dE5VvBNxBw4/giphy.gif?cid=ecf05e4716ff7f2ed9e29b26d1b2c3c7475488c6950bf2cf&rid=giphy.gif",
	  "https://media3.giphy.com/media/rt7Afig5wBUoo/giphy.gif?cid=ecf05e47ad5042d71209f6181f0db5963ad6ea0487a92d57&rid=giphy.gif"
	];
  index: any = 0;
  audio: any;
  sphereGroup: any;
  smallSphere: any;

  constructor() {}

  playAudio() {
    this.audio = new Audio();
    this.audio.src = '../../../assets/audio1.mp3';
    this.audio.load();
    this.audio.play();
  }

  pauseAudio() {
    this.audio.pause();
  }

  nextMood() {
    this.index > (this.backgrounds.length - 2) ? this.index = 0 : this.index++;
	document.getElementById('canvas_dancefloor').style.backgroundImage = 'url('+this.backgrounds[this.index]+')';
  }

  previousMood() {
    $('#canvas_dancefloor').fadeTo('slow', 0.3, () =>
    {
        console.log("HE");
        this.index == 0 ? this.index = 0 : this.index--;
        $('#canvas_dancefloor').css('background-image', 'url('+this.backgrounds[this.index]+')');
    }).fadeTo('slow', 1);
  }

  ngOnInit() {
    this.clock = new THREE.Clock();
	this.loader = new THREE.ColladaLoader();
	
	window.addEventListener("keydown", event => {
		if (event.keyCode === 32) {
		  this.nextMood();
		}
		// do something
	  });
	  setInterval(() => {
		  this.nextMood();
	  }, 6000)
		this.init();
  	}

	init() {
		this.container = document.getElementById('canvas_dancefloor');

		this.camera = new THREE.PerspectiveCamera( 45, window.innerWidth / window.innerHeight, 1, 1000 );
		this.camera.position.set( 0, 7, -30 );

		this.scene = new THREE.Scene();

    	this.loader = new THREE.ColladaLoader();

		this.loadCharacter( './assets/bigboss.dae', [0, 0, -2]);
		this.loadCharacter( './assets/spiderman.dae', [5, 0, 1])
		this.loadCharacter( './assets/spiderman.dae', [-5, 0, 1])

		this.addLight();
		this.addFloor();
		this.addAccessories();

		this.renderer = new THREE.WebGLRenderer( { antialias: true, alpha: true } );
		this.renderer.setPixelRatio( window.devicePixelRatio );
		this.renderer.setSize( window.innerWidth, window.innerHeight );
		this.container.appendChild( this.renderer.domElement );

		let controls = new THREE.OrbitControls( this.camera, this.renderer.domElement );
		controls.screenSpacePanning = true;
		controls.minDistance = 5;
		controls.maxDistance = 40;
		controls.target.set( 0, 2, 0 );
		controls.update();
    	this.addClickListener();

		window.addEventListener( 'resize', () => {
			this.camera.aspect = window.innerWidth / window.innerHeight;
			this.camera.updateProjectionMatrix();

			this.renderer.setSize( window.innerWidth, window.innerHeight );
		}, false );


		this.clock = new THREE.Clock();
    	subThis = this;
    	this.animate();
	}

	addLight() {
		let ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
		this.scene.add(ambientLight);
		var light = new THREE.PointLight( 0xffffff, 1, 100 );
		light.position.set( -50, 50, 0 );
		this.scene.add( light );
	}

	addAccessories() {
		const image = new THREE.TextureLoader().load("./assets/tv.jpeg")
		const tvMaterials = [
			new THREE.MeshBasicMaterial({
				color: 0x000000, //left
				side: THREE.DoubleSide,
			}),
			new THREE.MeshBasicMaterial({
				color: 0x000000, //right
			}),
			new THREE.MeshBasicMaterial({
				color: 0x000000, // top
			}),
			new THREE.MeshBasicMaterial({
				color: 0x000000, // bottom
			}),
			// Sides
			new THREE.MeshBasicMaterial({
				color: 0x000000, // top
			}),
			new THREE.MeshBasicMaterial({
				map: image, // top
				side: THREE.DoubleSide,
			}),
		];

		var planeGeo = new THREE.BoxGeometry( 15, 9, .5 );
		let tv = new THREE.Mesh( planeGeo, tvMaterials );
		tv.position.z = 10;
		tv.position.y = 7;
		this.scene.add( tv );

	}

	addFloor() {
		const wood = new THREE.TextureLoader().load("./assets/wood.jpg")
		const cubeMaterials = [
			new THREE.MeshBasicMaterial({
				map: wood, //left
				side: THREE.DoubleSide,
			}),
			new THREE.MeshBasicMaterial({
				map: wood, //right
				side: THREE.DoubleSide,
			}),
			new THREE.MeshBasicMaterial({
				map: wood, // top
				side: THREE.DoubleSide,
			}),
			new THREE.MeshBasicMaterial({
				map: wood, // bottom
				side: THREE.DoubleSide,
			}),
			// Sides
			new THREE.MeshBasicMaterial({
				map: wood, // bottom
				side: THREE.DoubleSide,
			}),
			new THREE.MeshBasicMaterial({
				map: wood, // bottom
				side: THREE.DoubleSide,
			}),
		];
		var planeGeo = new THREE.BoxGeometry( 23, 12, 1 );
		var sidePlaneGeo = new THREE.BoxGeometry( 12, 12, 1 );

		let tableTop = new THREE.Mesh( planeGeo, cubeMaterials );
		tableTop.rotation.x = - Math.PI / 2;
		tableTop.position.y = -.5;
		tableTop.position.z = -.5;

		let planeFront = new THREE.Mesh( planeGeo, cubeMaterials );
		planeFront.rotation.x = - Math.PI;
		planeFront.position.y = -7;
		planeFront.position.z = -6;

		
		var planeRight = new THREE.Mesh( sidePlaneGeo, cubeMaterials );
		planeRight.position.x = 12;
		planeRight.position.y = -6.5;
		planeRight.rotateY( - Math.PI / 2 )
		
		var planeLeft = new THREE.Mesh( sidePlaneGeo, cubeMaterials );
		planeLeft.position.x = -12;
		planeLeft.position.y = -6;
		planeLeft.rotateY( - Math.PI / 2 );

		this.scene.add( tableTop );
		this.scene.add( planeFront );
		this.scene.add( planeLeft );
		this.scene.add( planeRight );
	}

	loadCharacter(url: any, position: any) {
		this.loader.load( url, ( collada ) => {
			if (collada.library.nodes) {
				delete collada.library.nodes["boss_Jacket_Geo"]
				delete collada.library.geometries["boss_Jacket_Geo-lib"]
			}
			let animations = collada.animations;
			let avatar = collada.scene;
			avatar.position.set(position[0], position[1], position[2]);
			avatar.scale.multiplyScalar(3);
			avatar.userData.info = {type: "sweater", price: 69.99, description: "This maroon hoodie is called “Trojan Trump”. It draws parallels to the Trojan horse tale of subterfuge where the Greeks invaded Troy in a wooden horse. These Greeks where invisible but still there in plain sight ready to destroy😈. I found it similar to Putin’s meddling in American political affairs leading to someone like Trump finding himself in a position of immense authority, granting him the ability to destroy from within"};
			avatar.rotateY(9.5);
			this.avatars.push(avatar);

			let mixer = new THREE.AnimationMixer( avatar );
			mixer.clipAction( animations[ 0 ] ).play();
			this.scene.add( avatar );
			this.mixers.push(mixer);
		} );
	}

  addClickListener() {
    const ray = new THREE.Raycaster();
    const mouse = new THREE.Vector2();
    document.addEventListener( 'click', (event: any)=> {
      event.preventDefault();
      mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
      mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
      ray.setFromCamera( mouse, this.camera );
      let intersects = ray.intersectObjects( this.avatars, true );
      if ( intersects.length > 0 ) {
          console.log("INTERSECT");
          this.selectedPiece = intersects[0].object.parent.parent.userData.info;
          console.log(this.selectedPiece)
      } else {
          console.log("NO INTERSECT");
      }
    }  , false );
  }


	animate() {
		requestAnimationFrame( subThis.animate );
		subThis.render();
	}

	render() {
    if (this.clock) var delta = this.clock.getDelta();
    var timer = Date.now() * 0.01;
    if (this.sphereGroup) {
      this.sphereGroup.rotation.y -= 0.002;
      this.smallSphere.position.set(
        Math.cos( timer * 0.1 ) * 30,
        Math.abs( Math.cos( timer * 0.2 ) ) * 20 + 5,
        Math.sin( timer * 0.1 ) * 30
      );
      this.smallSphere.rotation.y = ( Math.PI / 2 ) - timer * 0.1;
      this.smallSphere.rotation.z = timer * 0.8;
    }
		var i = 0;
		while (this.mixers[i]) {
			if (this.mixers[i] != undefined) {
				this.mixers[i].update(delta);
				i++;
			}
		}
		this.renderer.render( this.scene, this.camera );
	}


  close() {
    this.selectedPiece = null;
  }

}
